<template>
  <v-select
  	v-model="auxSelectedOrganization"
    :items="organizations"
    item-text="name"
    item-value="id"
    @change="updateSelectedOrganization"
    :label="$t('OrganizationFilter.organizationFilter')"
    return-object
    :solo="solo"
    :outlined="outlined"
    :menu-props="outlined ? { bottom: true, offsetY: true } : {}"
    hide-details
  />
</template>
<script>
import {firestore} from '@/plugins/firebase'
export default {
  props: ['selectedOrganization', 'allowedOrgs', 'solo', 'outlined'],
  data () {
    return {
      auxSelectedOrganization: '',
      organizations: []
    }
  },
  created () {
    firestore.then(db => {
      db.collection('app/v1/organizations').get().then(docs => {
        let auxOrgsList = []
        docs.forEach(doc => {
          const organization = {
            name: doc.data().name,
            id: doc.id,
            hubspotId: doc.data().hubspotId
          }
          auxOrgsList.push(organization)
        })

        if (this.allowedOrgs && this.allowedOrgs.length > 0) {
          auxOrgsList = auxOrgsList.filter(org => this.allowedOrgs.includes(org.id))
        }

        this.organizations = this.$ponceConfig.sortArrayByName(auxOrgsList)
      })
    })
    this.auxSelectedOrganization = this.selectedOrganization
  },
  methods: {
    updateSelectedOrganization () {
      this.$emit('update:selectedOrganization', this.auxSelectedOrganization.id)
      this.$store.dispatch('setSelectedOrganization', this.auxSelectedOrganization)
    }
  }
}
</script>


// WEBPACK FOOTER //
// OrganizationFilter.vue?20524736